import Root from "../layouts/Root";
import {getRandomColor} from "../utils/GetRandomColor";
import {useState, useEffect} from "react";
import LifeEventService from "../services/LifeEventService";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import * as Icons from '@fortawesome/free-solid-svg-icons';
import IconText from "../components/IconText";
import {faBarsProgress, faTableCells} from "@fortawesome/free-solid-svg-icons";

export default function Life() {
    const [lifeEvents, setLifeEvents] = useState([]);
    const birthDate = new Date('1997-12-24');
    const currentDate = new Date();
    const lifeExpectancy = 80;
    const totalWeeks = lifeExpectancy * 52;

    const weeksLived = Math.floor((currentDate - birthDate) / (1000 * 60 * 60 * 24 * 7));
    const currentAge = Math.floor((currentDate - birthDate) / (1000 * 60 * 60 * 24 * 365.25));
    const lifePercentage = Math.round((weeksLived / totalWeeks) * 100);

    useEffect(() => {
        const fetchLifeEvents = async () => {
            try {
                const events = await LifeEventService.getAllLifeEvent();
                setLifeEvents(events);
            } catch (error) {
                console.error('Failed to fetch life events:', error);
            }
        };
        fetchLifeEvents();
    }, []);

    const getWeekNumber = (eventDate) => {
        const date = new Date(eventDate);
        return Math.floor((date - birthDate) / (1000 * 60 * 60 * 24 * 7));
    };

    const getEventForWeek = (weekIndex) => {
        return lifeEvents.find(event => getWeekNumber(event.date) === weekIndex);
    };

    const getBirthdayAge = (weekIndex) => {
        // Check if this week is a birthday week (52 weeks per year)
        if (weekIndex % 52 === 0 && weekIndex > 0) {
            return weekIndex / 52;
        }
        return null;
    };

    const gridStyle = {
        display: 'grid',
        marginTop: '10px',
        gridTemplateColumns: 'repeat(26, 1fr)',
        width: '100%',
        gap: '2px',
        gridGap: '5px',
    };

    const boxStyle = {
        width: '100%',
        paddingBottom: '100%',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    };

    const iconStyle = {
        position: 'absolute',
        fontSize: '90%',
        color: 'white',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    };

    const ageStyle = {
        position: 'absolute',
        fontSize: '90%',
        fontWeight: 'bold',
        color: 'white',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    };

    const rightContent = (
        <div>
            <div style={{marginBottom: '50px'}}>
                <h1><IconText icon={faBarsProgress} text={"Progress"}></IconText></h1>
                <p>Assuming I live to be {lifeExpectancy}, it looks like I have completed {lifePercentage}% of my life so far.</p>
                <div style={{
                    width: '100%',
                    height: '40px',
                    backgroundColor: '#555555',
                    position: 'relative',
                    overflow: 'hidden',
                    marginTop: '10px',
                }}>
                    <div style={{
                        width: `${lifePercentage}%`,
                        height: '100%',
                        backgroundColor: getRandomColor(),
                        transition: 'none',
                    }}></div>
                    <span style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        color: 'white',
                        fontWeight: 'bold',
                        fontSize: '16px',
                    }}>
        {lifePercentage}%
    </span>
                </div>
                <div style={{
                    position: 'relative',
                    width: '100%',
                    marginTop: '5px',
                    fontSize: '14px',
                    color: '#ddd',
                }}>
                    <span style={{position: 'absolute', left: '0'}}>0</span>
                    <span style={{position: 'absolute', left: `${lifePercentage}%`, transform: 'translateX(-50%)'}}>
        {currentAge}
    </span>
                    <span style={{position: 'absolute', right: '0'}}>{lifeExpectancy}</span>
                </div>
            </div>

            <h1><IconText icon={faTableCells} text={"Visualization"}></IconText></h1>
            <p>Each box represents one week of my life.</p>
            <div style={gridStyle}>
                {Array.from({length: totalWeeks}, (_, index) => {
                    const event = getEventForWeek(index);
                    const icon = event && event.emoji ? Icons[event.emoji] : null;
                    const birthdayAge = getBirthdayAge(index);

                    return (
                        <div key={index} style={{
                            ...boxStyle,
                            backgroundColor: index < weeksLived ? getRandomColor(index) : '#555555',
                            outline: event ? '5px solid white' : 'none',
                        }}
                             title={event ? event.label : (birthdayAge ? `Birthday: Age ${birthdayAge}` : '')}
                        >
                            {icon && <FontAwesomeIcon icon={icon} style={iconStyle}/>}
                            {birthdayAge && !icon && <span style={ageStyle}>{birthdayAge}</span>}
                        </div>
                    );
                })}
            </div>
        </div>
    )
    return (
        <div className="weeks-page">
            <Root rightContent={rightContent}/>
        </div>
    )
}
